// Core
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 0 32px 0;
`;

export const CardContent = styled.div`
  width: 296px;
`;

export const DiagnosticsSection = styled.div`
  margin-top: 16px;
`;

export const DiagnosticsCardsContainer = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 16px;
`;
